import { memo, useEffect, useState } from 'react'
import LazyLoad from 'react-lazyload'

import Ad from '@/components/Ad/Ad'
import { useAds } from '@/contexts/ads'

import styles from './Leaderboard.module.scss'

const rollAdId = (country?: string) => {
  const randomRoll = Math.random()
  const randomRollTwo = Math.random()

  // Non-US users have a 50% chance to see TCGPlayer International ad
  // The remaining 50% receives the normal ad setup
  if (country !== 'US' && randomRollTwo > 0.5) {
    return 'tcgplayerIntl'
  } else {
    /* Ad Setup:
     - 20% Card Kingdom Buylist

     - Half of remainder split between SCM
     - Other half of remainder goes to EDHREC Patreon
  */
    if (randomRoll === 0) return null
    else if (randomRoll < 0.2) return 'ckBuylist'
    else if (randomRoll < 0.2 + 0.8 * (1 / 14)) return 'archidekt'
    else if (randomRoll < 0.2 + 0.8 * (2 / 14)) return 'crossword'
    else if (randomRoll < 0.2 + 0.8 * (3 / 14)) return 'cs'
    else if (randomRoll < 0.2 + 0.8 * (4 / 14)) return 'csb'
    else if (randomRoll < 0.2 + 0.8 * (5 / 14)) return 'edhrecap'
    else if (randomRoll < 0.2 + 0.8 * (6 / 14)) return 'edhrecast1'
    else if (randomRoll < 0.2 + 0.8 * ((6 + 1 / 3) / 14)) return 'edhrecast2'
    else if (randomRoll < 0.2 + 0.8 * ((6 + 2 / 3) / 14)) return 'edhrecast3'
    else if (randomRoll < 0.2 + 0.8 * (6.25 / 14)) return 'spellifyDark1'
    else if (randomRoll < 0.2 + 0.8 * (6.5 / 14)) return 'spellifyDark2'
    else if (randomRoll < 0.2 + 0.8 * (6.75 / 14)) return 'spellifyLight1'
    else if (randomRoll < 0.2 + 0.8 * (7 / 14)) return 'spellifyLight2'
    else if (randomRoll < 0.2 + 0.8 * (7 / 14 + 1 / 8)) return 'edhrecPatreon'
    else if (randomRoll < 0.2 + 0.8 * (7 / 14 + 2 / 8)) return 'edhrecPatreon201'
    else if (randomRoll < 0.2 + 0.8 * (7 / 14 + 3 / 8)) return 'edhrecPatreon202'
    else return 'edhrecPatreon203'
  }
}

type Props = {
  country?: string
}

const Leaderboard = ({ country }: Props) => {
  const { loadAds } = useAds()
  const [adId, setAdId] = useState<string | null>(null)

  useEffect(() => {
    setAdId(rollAdId(country))
  }, [country])

  if (loadAds === undefined) return <div className={styles.container} />

  return (
    <div className={styles.container}>
      <div className={styles.leaderboard}>
        <LazyLoad>{adId && <Ad id={adId} />}</LazyLoad>
      </div>
    </div>
  )
}

export default memo(Leaderboard)
